import script from "./PopupContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupContainer.vue?vue&type=script&setup=true&lang=ts"

import "./PopupContainer.vue?vue&type=style&index=0&id=735b4be7&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-735b4be7"]])

export default __exports__